import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 14c0 4.546 3.5 8 8 8s8-3.454 8-8c0-8.182-8-12-8-12 0 4 1 10-2 10-2 0-2.5-2-2.5-5.5C7.5 6.5 4 9.455 4 14Z"
    />
  </svg>
)
export default SvgComponent
